__turbopack_context__.v({
  "checkGroup": "FloatsSubmissions-module__bN4V4W__checkGroup",
  "fieldGrid": "FloatsSubmissions-module__bN4V4W__fieldGrid",
  "headingGrid": "FloatsSubmissions-module__bN4V4W__headingGrid",
  "previewButton": "FloatsSubmissions-module__bN4V4W__previewButton",
  "sectionHeading": "FloatsSubmissions-module__bN4V4W__sectionHeading",
  "styleGrid": "FloatsSubmissions-module__bN4V4W__styleGrid",
  "styleLabel": "FloatsSubmissions-module__bN4V4W__styleLabel",
  "styleOption": "FloatsSubmissions-module__bN4V4W__styleOption",
  "styleOptionSelected": "FloatsSubmissions-module__bN4V4W__styleOptionSelected",
  "styleScaler": "FloatsSubmissions-module__bN4V4W__styleScaler",
});
